.page {
  min-block-size: 100dvh;
  display: flex;
  flex-direction: column;
  background: var(--surface-0);
  color: var(--text-1);
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  inline-size: 100%;
  max-inline-size: 820px;
  margin-inline: auto;
  padding: var(--space-3) var(--space-4);
}
.logo {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: var(--font-size-5);
  letter-spacing: -0.03em;
  color: var(--accent);
  text-decoration: none;
}
.tools {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}
.tool {
  display: inline-flex;
  align-items: center;
  min-block-size: var(--touch-target);
  padding-inline: var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-full);
  background: var(--surface-0);
  color: var(--text-1);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.main {
  flex: 1;
  inline-size: 100%;
  max-inline-size: 820px;
  margin-inline: auto;
  padding: var(--space-4) var(--space-4) var(--space-8);
}
.article {
  line-height: 1.65;
  overflow-wrap: anywhere;
}
.article h1 {
  margin-block: var(--space-2) var(--space-1);
  font-size: clamp(1.75rem, 4vw, 2.25rem);
}
.article h2 {
  margin-block: var(--space-6) var(--space-2);
  font-size: var(--font-size-3);
}
.article p,
.article ul {
  margin-block: 0 var(--space-3);
}
.article ul {
  padding-inline-start: var(--space-5);
}
.article li + li {
  margin-block-start: var(--space-1);
}
.updated {
  color: var(--text-2);
  font-size: var(--font-size-1);
}
.intro {
  font-size: var(--font-size-3);
}
.footer {
  border-block-start: 1px solid var(--border);
  padding: var(--space-4);
}
.links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-2) var(--space-4);
  font-size: var(--font-size-1);
}
.links a,
.linkButton {
  color: var(--text-2);
  text-decoration: underline;
  text-underline-offset: 2px;
}
.linkButton {
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  cursor: pointer;
}
.links a:hover,
.linkButton:hover {
  color: var(--text-1);
}
